import axios from 'axios'

export default () => ({
  open(event, address) {

    axios.get('/account/addresses/ajax/delete', {
      params: {
        address: address
      }
    })
      .then(response => {
        this.$dispatch('modal-open', {
          content: response.data.template
        })
      })
  }
})
